import { useState, useCallback, useEffect } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import { Box } from "@mui/system";
import {
  Icon,
  Input,
  Search,
  TabContainer,
  TabLinkContainer,
} from "../../pages/Dashboard/styles/dashboard.style";
import Popover from "@mui/material/Popover";
import PropTypes from "prop-types";
import { ImgTextDiv, StatusBadge } from "../../pages/student_mgt/stu_mgt.style";
import Avatar from "../../assets/Images/avatar.jpg";
import {
  IconButton,
  MenuItem,
  MenuList,
  Modal,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { BsSearch } from "react-icons/bs";
import {
  fetchAllLeavesRequest,
  UpdateLeaveRequest,
} from "../../services/humanResources";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import TableLoader from "../TableLoader";
import { FormateDate } from "../../utils";
import { NewPagination } from "../pagination_one/NewPaginations";
import PreviewModal from "./PreviewModal";
import { StyledTableCell, StyledTableRow } from "../CBT/CBTFirst";

const ApprovalLeave = () => {
  const accountStatus = [
    { id: 0, name: "Pending" },
    { id: 1, name: "Approved" },
    { id: 2, name: "Declined" },
  ];

  let initialFilters = {
    schoolId: 0,
    searchText: "",
    status: 0,
    pageNumber: 1,
    pageSize: 10,
  };

  const [filters, setFilters] = useState(initialFilters);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedStaff, setSelectedStaff] = useState([]);
  const [loadingUploading, setLoadingUploading] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const { admToken, user } = useSelector((state) => state.auth);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [actionStatus, setActionStatus] = useState(null); // 1 or 6
  const [files, setFiles] = useState([]);
  const [previewUrls, setPreviewUrls] = useState([]);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);

      const res = await fetchAllLeavesRequest({
        token: admToken,
        schoolId: user?.schoolId,
        status: filters.status,
        searchText: filters.searchText,
        pageSize: filters.pageSize,
        pageNumber: filters.pageNumber,
      });

      if (res.status && res.statusCode === 2) {
        setData(res.data.records);
        setTotalPages(res.data.records.totalPages);
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [filters, admToken]);

  useEffect(() => {
    fetchData();
  }, [filters, fetchData]);

  const toggleSelect = (id) => {
    setSelectedStaff((prev) => (prev.includes(id) ? [] : [id]));
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);

    setFiles(selectedFiles);

    const previews = selectedFiles.map((file) => ({
      url: URL.createObjectURL(file),
      type: file.type,
      name: file.name,
    }));

    setPreviewUrls(previews);
  };

  const removeFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));

    setPreviewUrls((prev) => {
      URL.revokeObjectURL(prev[index].url);
      return prev.filter((_, i) => i !== index);
    });
  };

  // const handleSubmit = async (newStatus) => {
  //   try {
  //     const payload = {
  //       status: newStatus,
  //       requestIds: selectedStaff,
  //     };
  //     setLoadingUploading(true);

  //     const res = await UpdateLeaveRequest(admToken, payload);

  //     if (res.status && res.statusCode === 2) {
  //       toast.success(res.message);
  //       setSelectedStaff([]);
  //       setSelectAll(false);
  //       fetchData();
  //     } else {
  //       toast.error(res.message);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     setLoadingUploading(false);
  //   }
  // };

  const submitWithFiles = async () => {
    if (!files.length) {
      toast.error("Please upload at least one file");
      return;
    }

    const formData = new FormData();
    formData.append("status", actionStatus);

    selectedStaff.forEach((id) => formData.append("requestIds", id));

    files.forEach((file) => formData.append("files", file));

    try {
      setLoadingUploading(true);
      const res = await UpdateLeaveRequest(admToken, formData);

      if (res.status && res.statusCode === 2) {
        toast.success(res.message);
        setSelectedStaff([]);
        setFiles([]);
        setPreviewUrls([]);
        setShowUploadModal(false);
        fetchData();
      } else {
        toast.error(res.message);
      }
    } finally {
      setLoadingUploading(false);
    }
  };

  const handlePopoverOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedItem(row);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const openPreview = (url) => {
    setPreviewUrl(url);
    setPreviewOpen(true);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <>
      {/* {showModal && (
        <Modal
          content={content}
          size={"large"}
          onClose={setShowModal}
          start={true}
        />
      )} */}

      <div style={{ marginTop: "0.7rem" }}>
        <TabContainer style={{ paddingBottom: "0px" }}>
          <TabLinkContainer bg="#EEE0F1">
            <Input>
              <Icon>
                <BsSearch />
              </Icon>
              <Search
                type="text"
                placeholder="Search"
                value={filters.searchText}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    searchText: e.target.value,
                    pageNumber: 1,
                  })
                }
              />
            </Input>
          </TabLinkContainer>
          <TableContainer
            pt="0px"
            sx={{ overflow: "hidden", borderRadius: "0px" }}
          >
            <Table
              sx={{ minWidth: 700, fontFamily: "Gilroy-Regular" }}
              aria-label="customized table"
            >
              <TableHead
                sx={{
                  backgroundColor: "rgba(103, 30, 120, 0.1)",
                  width: "100%",
                }}
              >
                <TableRow>
                  <StyledTableCell></StyledTableCell>
                  <StyledTableCell>LASMAB NO</StyledTableCell>
                  <StyledTableCell>Staff Name</StyledTableCell>
                  <StyledTableCell>Type</StyledTableCell>
                  <StyledTableCell>Duration</StyledTableCell>
                  <StyledTableCell>Start Date</StyledTableCell>
                  <StyledTableCell>End Date </StyledTableCell>
                  <StyledTableCell>Status</StyledTableCell>
                  <StyledTableCell>Applied Date</StyledTableCell>
                  <StyledTableCell></StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody sx={{ fontFamily: "Gilroy-Regular" }}>
                {loading ? (
                  <StyledTableRow colSpan={6} align="center">
                    <StyledTableCell>
                      <div className="flex items-center justify-center">
                        <TableLoader />
                      </div>
                    </StyledTableCell>
                  </StyledTableRow>
                ) : data?.length > 0 ? (
                  data?.map((staff) => {
                    const staffFullName =
                      `${staff?.firstName} ${staff?.lastName} ${staff.otherName}`.trim();
                    const isSelectable =
                      staff?.status === 0 || staff?.status === 2;

                    return (
                      <StyledTableRow key={staff?.requestId}>
                        {/* Checkbox - only if status is 1 or 2 */}
                        <StyledTableCell>
                          {isSelectable && (
                            <input
                              type="checkbox"
                              checked={selectedStaff.includes(staff?.requestId)}
                              onChange={() => toggleSelect(staff?.requestId)}
                            />
                          )}
                        </StyledTableCell>
                        <StyledTableCell>{staff?.lasmabNo}</StyledTableCell>

                        {/* Staff Name */}
                        <StyledTableCell>
                          <ImgTextDiv>
                            <img src={staff?.photo || Avatar} alt="" />
                            <span>{staffFullName}</span>
                          </ImgTextDiv>
                        </StyledTableCell>

                        <StyledTableCell>{staff?.requestType}</StyledTableCell>
                        <StyledTableCell>
                          {staff?.duration} Days
                        </StyledTableCell>
                        <StyledTableCell>
                          {FormateDate(staff?.startDate)}
                        </StyledTableCell>
                        <StyledTableCell>
                          {FormateDate(staff?.endDate)}
                        </StyledTableCell>
                        <StyledTableCell>
                          <StatusBadge status={staff.status}>
                            {accountStatus?.find((s) => s.id === staff?.status)
                              ?.name || "Pending"}
                          </StatusBadge>
                        </StyledTableCell>
                        <StyledTableCell>
                          {FormateDate(staff?.appliedOn)}
                        </StyledTableCell>
                        <StyledTableCell>
                          <IconButton
                            onClick={(e) => handlePopoverOpen(e, staff)}
                          >
                            <MoreVertIcon />
                          </IconButton>
                        </StyledTableCell>
                      </StyledTableRow>
                    );
                  })
                ) : (
                  <StyledTableRow colSpan={6} align="center">
                    <StyledTableCell>
                      <p className="text-center">No Available Staff</p>
                    </StyledTableCell>
                  </StyledTableRow>
                )}
              </TableBody>
            </Table>
            {/* APPROVE / DELETE BUTTONS */}
            <div className="flex gap-4 items-center justify-end mt-4 px-5 py-2.5">
              <button
                disabled={selectedStaff.length !== 1}
                onClick={() => {
                  setActionStatus(1);
                  setShowUploadModal(true);
                }}
                className="rounded-lg min-w-[121px] text-white bg-primary p-3 cursor-pointer leading-[2.125rem]! border border-primary font-bold disabled:opacity-80 disabled:cursor-not-allowed"
              >
                Approve
              </button>

              <button
                disabled={selectedStaff.length !== 1}
                onClick={() => {
                  setActionStatus(6);
                  setShowUploadModal(true);
                }}
                className="rounded-lg min-w-[121px] text-white bg-primary p-3 cursor-pointer leading-[2.125rem]! border border-primary font-bold disabled:opacity-80 disabled:cursor-not-allowed"
              >
                Decline
              </button>
            </div>
          </TableContainer>
        </TabContainer>
      </div>
      <div className="my-2.5">
        <NewPagination
          pageCount={totalPages}
          currentPage={filters.pageNumber}
          range={3}
          setCurrentPage={(page) =>
            setFilters((prev) => ({ ...prev, pageNumber: page }))
          }
        />
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box
          sx={{
            bgcolor: "#671E78",
            color: "#fff",
            fontFamily: "Gilroy-Regular",
            px: 3,
            py: 1,
            minWidth: "200px",
          }}
        >
          <MenuList sx={{ fontFamily: "Gilroy-Regular" }}>
            {selectedItem?.documents?.length > 0 ? (
              selectedItem.documents.map((doc, index) => (
                <MenuItem
                  key={index}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <span>Document {index + 1}</span>

                  <div className="flex gap-3 pl-5">
                    {/* Preview Button */}
                    <button
                      onClick={() => {
                        handleClose();
                        openPreview(doc);
                      }}
                      style={{
                        background: "transparent",
                        border: "1px solid white",
                        color: "white",
                        padding: "2px 6px",
                        borderRadius: "4px",
                      }}
                    >
                      Preview
                    </button>

                    {/* Download Button */}
                    {/* <a
                      href={doc}
                      download
                      style={{
                        background: "white",
                        color: "#671E78",
                        padding: "2px 6px",
                        borderRadius: "4px",
                        fontWeight: "bold",
                        textDecoration: "none",
                      }}
                    >
                      Download
                    </a> */}
                  </div>
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>No Documents</MenuItem>
            )}
          </MenuList>
        </Box>
      </Popover>
      <PreviewModal
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
        url={previewUrl}
      />
      {showUploadModal && (
        <Modal open={showUploadModal} onClose={() => setShowUploadModal(false)}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "white",
              borderRadius: 2,
              boxShadow: 24,
              p: 4,
              width: 500,
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
            <h3 className="font-bold text-lg mb-3">
              Upload Supporting Document
            </h3>

            <input
              type="file"
              multiple
              accept="application/pdf,image/*"
              onChange={handleFileChange}
            />

            {previewUrls.length > 0 && (
              <div className="grid grid-cols-2 gap-4 mt-4">
                {previewUrls.map((file, i) => (
                  <div key={i} className="relative border p-2 rounded">
                    <button
                      onClick={() => removeFile(i)}
                      className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-6 h-6"
                    >
                      ✕
                    </button>

                    {file.type.startsWith("image/") ? (
                      <img
                        src={file.url}
                        className="h-32 w-full object-cover"
                      />
                    ) : (
                      <iframe src={file.url} className="h-32 w-full" />
                    )}

                    <p className="text-xs mt-1 truncate">{file.name}</p>
                  </div>
                ))}
              </div>
            )}

            <div className="flex justify-end gap-2 mt-5">
              <button onClick={() => setShowUploadModal(false)}>Cancel</button>
              <button
                onClick={submitWithFiles}
                disabled={loadingUploading}
                className="bg-primary text-white px-4 py-2 rounded"
              >
                {loadingUploading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </Box>
        </Modal>
      )}
    </>
  );
};

ApprovalLeave.propTypes = {
  showOnlyList: PropTypes.bool,
};

ApprovalLeave.defaultProps = {
  showOnlyList: false,
};

export default ApprovalLeave;
